module.exports = "/_next/static/images/iShares-7b947cf348764dfb76eb5123f68b7afe.svg";